import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
export function Languages({
  languages
}) {
  return /*#__PURE__*/_jsx(FormattedList, {
    children: languages.map(languageCode => [languageCode, `SharedI18nStrings.languageNames.${languageCode}`]).sort(([__, languageNameI18nKey], [___, nextLanguageNameI18nKey]) => unescapedText(languageNameI18nKey).localeCompare(unescapedText(nextLanguageNameI18nKey))).map(([languageCode, languageNameI18nKey]) => /*#__PURE__*/_jsx(FormattedMessage, {
      message: languageNameI18nKey
    }, languageCode))
  });
}